import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { Paginator } from "primereact/paginator";
import { Ripple } from "primereact/ripple";
import { Toaster } from "react-hot-toast";
import moment from "moment/moment";
import Cookies from "js-cookie";
import { TitleContext } from "../../../../Context/TitleContext";
import { useAxios, API_URL } from "../../../../utils/const";
import { useToast } from "../../../../Context/ToastContext";

const CourseAttendancesHistory = () => {
  const { setTitle } = useContext(TitleContext);
  const axiosInstance = useAxios();
  const { setToastObj } = useToast();
  const { id } = useParams();
  const location = useLocation();
  const { data } = location.state || {}; // Destruktur state

  const [courseTimetables, setCourseTimetables] = useState({
    courseTimetables: [],
    totalRecords: 0,
  });
  const [courseTimetableRecords, setCourseTimetableRecords] = useState([]);

  const [userRole, setUserRole] = useState("");

  const [pagination, setPagination] = useState({ first: 0, rows: 10, page: 0 });
  const [rowPerPage, setRowPerPage] = useState(10);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTitle("USAKTI | Data Kehadiran Mahasiswa"); // Set judul halaman
  }, [setTitle]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await getCourseSessions();
      } catch (error) {
        setToastObj({
          msg: error,
          type: "danger",
        });
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [pagination]);

  const getCourseSessions = async () => {
    try {
      const response = await axiosInstance.post(
        `${API_URL}/course-sessions/student/find-by-student-id/timetables`
      );

      // Ambil data hasil response
      const fetchedData = response.data.data;

      // Filter data berdasarkan data.name
      const filteredData = fetchedData.filter(
        (item) => item.courseGroup?.course?.name === data.name
      );

      // Set hasil filter ke state
      setCourseTimetables({
        courseTimetables: filteredData,
        totalRecords: filteredData.length, // Sesuaikan total dengan hasil filter
      });
      setCourseTimetableRecords(filteredData);
    } catch (error) {
      console.error("Failed to fetch course sessions:", error);
    }
  };

  const formatDate = (isoDate) => {
    // Format using moment
    return moment(isoDate).format("DD MMMM YYYY");
  };

  const paginationTemplate = {
    layout: "PrevPageLink PageLinks NextPageLink ",
    PrevPageLink: (options) => {
      return (
        <button
          type="button"
          className="btn border"
          onClick={options.onClick}
          disabled={options.disabled}
        >
          <span className="p-3">Previous</span>
          <Ripple />
        </button>
      );
    },
    NextPageLink: (options) => {
      return (
        <button
          type="button"
          className="btn border"
          onClick={options.onClick}
          disabled={options.disabled}
        >
          <span className="p-3">Next</span>
          <Ripple />
        </button>
      );
    },
  };

  const rowsPerPageOptions = [10, 25, 50, 100];

  const onPageChange = async (event) => {
    setPagination({ first: event.first, rows: event.rows, page: event.page });
  };

  return loading == false ? (
    <div>
      <Toaster position="top-right" />
      <div className="container-fluid">
        <div className="card mb-4">
          <div className="card-body">
            <h1>Data Kehadiran Mahasiswa</h1>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <Link>Daftar Modul</Link>
              </li>
              <li className="breadcrumb-item active">
                Data Kehadiran Mahasiswa
              </li>
            </ol>
          </div>
        </div>

        <div className="card">
          <div className="card-body m-3">
            <div className="row mt-3">
              <div className="col-md-4 text-center offset-md-4">
                <h4>Kehadiran</h4>
              </div>
            </div>

            <div className="row">
              {/* SEARCH */}
              <div className="row mt-4">
                <div className="col-md-6">
                  <label>Show</label>
                  <select
                    value={rowPerPage}
                    onChange={(e) => setRowPerPage(parseInt(e.target.value))}
                    className="form-select form-select-sm d-inline-block w-auto ms-2"
                  >
                    {rowsPerPageOptions.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                  <label style={{ marginLeft: "5px" }}>entries</label>
                </div>
              </div>

              <div className="table-responsive">
                {/* Tabel Data Jadwal Kelas */}
                <table className="table table-striped mt-3">
                  <thead>
                    <tr>
                      <th>NO</th>
                      <th>TANGGAL</th>
                      <th>JAM</th>
                      <th>MODUL</th>
                      <th>TOPIK</th>
                      <th>TIPE</th>
                      <th>RUANGAN</th>
                      <th>PENGAJAR</th>
                      <th>STATUS</th>
                      <th className="text-center">AKSI</th>
                    </tr>
                  </thead>
                  <tbody>
                    {courseTimetableRecords.map((item, index) => (
                      <tr key={index}>
                        <td>{pagination.first + index + 1}</td>
                        <td>{formatDate(item.date)}</td>
                        <td>
                          {item.start_time} - {item.end_time}
                        </td>
                        <td>{item.courseGroup.course.name}</td>
                        <td>{item.courseTopic.topic}</td>
                        <td>{item.course_type}</td>
                        <td>{item.classroom.name}</td>
                        <td>
                          {item.lecturers
                            .map((lecturer) => lecturer.lecturer.name)
                            .join(", ")}
                        </td>
                        <td>
                          {item.status === 0 ? (
                            <span className="badge text-white text-bg-info">
                              ON SCHEDULE
                            </span>
                          ) : item.status === 1 ? (
                            <span className="badge text-white text-bg-warning">
                              ON GOING
                            </span>
                          ) : item.status === 2 ? (
                            <span className="badge text-white text-bg-success">
                              FINISHED
                            </span>
                          ) : item.status === 3 ? (
                            <span className="badge text-white text-bg-danger">
                              CANCELED
                            </span>
                          ) : (
                            <span className="badge text-white text-bg-secondary">
                              UNKNOWN
                            </span>
                          )}
                        </td>
                        <td className="text-center">
                          {(item.course_type === "TUTORIAL (SESI 1)" ||
                            item.course_type === "TUTORIAL (SESI 2)") && (
                            <Link
                              to={{
                                pathname: `/akademik/course-attendance/logbook/detail/${item.id}/${item.course_type}`,
                              }}
                              className="btn btn-success text-white btn-sm"
                            >
                              <i className="fa fa-clipboard-list"></i>
                            </Link>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Paginator dari PrimeReact */}
              <div className="row">
                <div className="col-md-6 d-flex align-items-center h-100">
                  <p>
                    Showing {pagination.first + 1} to{" "}
                    {rowPerPage > courseTimetables.totalRecords
                      ? courseTimetables.totalRecords
                      : rowPerPage}{" "}
                    of {courseTimetables.totalRecords} entries
                  </p>
                </div>
                <div className="col-md-6">
                  <Paginator
                    first={pagination.first}
                    rows={pagination.rows}
                    totalRecords={courseTimetables.totalRecords}
                    onPageChange={onPageChange}
                    template={paginationTemplate}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div>
      <div className="row">
        <div
          className="col-md-12 text-center align-center"
          style={{ marginTop: "20%" }}
        >
          <h1>Mohon Tunggu</h1>
        </div>
      </div>
    </div>
  );
};

export default CourseAttendancesHistory;
